import React from 'react';

import {DocumentList} from 'components/documents';
import {statuses} from '../statuses';
import config from 'config'; 

export const MailInformation = ({ mail }) => (
  <DocumentList>
    <li>Дата розсилки: <strong>{new Date(mail.get('time_mailing')).toLocaleString('uk-UA', config.options)}</strong></li>
    <li>Термін виконання розсилки: <strong>{new Date(mail.get('time_deadline')).toLocaleString('uk-UA', config.options)}</strong></li>
    <li>Стан розсилки: <strong>{statuses[mail.get('current_status')]}</strong></li>
    <li>Опис розсилки: <strong>{mail.get('comment_mailing') ? mail.get('comment_mailing') : "Опис відсутній"}</strong></li>
  </DocumentList>
)



// WEBPACK FOOTER //
// ./src/operator/mailing/detail/mail-information.js